import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import Modal from "react-modal";
import { FaExclamationTriangle } from "react-icons/fa";
import ModalClose from "./ModalClose";

const FormExit = (props) => {
  let { closeModal, toggleModal, renderDeleteButton, renderSaveButton } = props;

  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

  const toggleDeleteConfirmation = () => {
    setDeleteConfirmationOpen(!deleteConfirmationOpen);
  };

  return (
    <>
      <Modal
        isOpen={closeModal && !deleteConfirmationOpen}
        className="Form-Modal"
        overlayClassName="Overlay"
      >
        <ModalClose toggleModal={(e) => toggleModal()} />

        <p className="modal-centered-icon">
          <FaExclamationTriangle color={"#e9e9e9"} size={"4em"} />
        </p>

        <h3>Are you sure you want to quit?</h3>
        <p>
          You can access this form in <b>My Cases</b>.{" "}
        </p>

        <form>{renderSaveButton()}</form>
        <button
          style={{
            color: "rgb(3, 65, 110)",
            cursor: "pointer",
            fontSize: "0.75rem",
            textDecoration: "underline",
            background: "none",
            border: "none",
            padding: "0",
          }}
          type="button"
          onClick={toggleDeleteConfirmation}
        >
          Delete Case?
        </button>
      </Modal>
      <Modal
        isOpen={deleteConfirmationOpen}
        className="Form-Modal"
        overlayClassName="Overlay"
      >
        <ModalClose toggleModal={(e) => toggleDeleteConfirmation()} />

        <p className="modal-centered-icon">
          <FaExclamationTriangle color={"#e9e9e9"} size={"4em"} />
        </p>

        <h3>Are you sure you want to delete this application?</h3>

        <form>{renderDeleteButton()}</form>
        <button
          style={{
            color: "rgb(3, 65, 110)",
            cursor: "pointer",
            fontSize: "0.75rem",
            textDecoration: "underline",
            background: "none",
            border: "none",
            padding: "0",
          }}
          type="button"
          onClick={toggleDeleteConfirmation}
        >
          Go back
        </button>
      </Modal>
    </>
  );
};

export default withRouter(FormExit);
